import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '400px', padding: '40px',
          textAlign: 'center', background: '#111827'
        }}>
          <div style={{ fontSize: '56px', marginBottom: '20px' }}>⚠️</div>
          <h2 style={{ color: '#f3f4f6', fontSize: '22px', fontWeight: 'bold', margin: '0 0 10px' }}>
            Something went wrong
          </h2>
          <p style={{ color: '#9ca3af', fontSize: '14px', maxWidth: '400px', lineHeight: '1.6', margin: '0 0 28px' }}>
            {this.state.error?.message || 'An unexpected error occurred. This section failed to load.'}
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              background: '#3b82f6', color: '#fff', border: 'none',
              padding: '10px 28px', borderRadius: '8px', cursor: 'pointer',
              fontSize: '14px', fontWeight: '600'
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
